import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Variables } from "../../../Variations/Variations";
import { BiImage } from "react-icons/bi";
import { PaginatedList } from "react-paginated-list";
import Cookies from "js-cookie";
function VariationGallery(props) {
  const values = [true, "sm-down", "md-down", "lg-down", "xl-down", "xxl-down"];
  const token = Cookies.get("UserToken");
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [showMore, setShowMore] = useState(true);
  const [showImageDetails, setShowImageDetails] = useState(false);
  const [imageDetails, setImageDetails] = useState({});
  const [uploadedImages, setUploadedImages] = useState([]);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
    fetchMedia();
  }

  const [Media, setMedia] = useState([]);
  const [filteredData, setFilteredData] = useState(Media);

  let NUM_OF_RECORDS = Media.length;
  let LIMIT = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const currentData = filteredData.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );

  const onPageChanged = useCallback(
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
  );

  function handleImages(e, id, image) {
    var index = 0;
    var updatedList = [...props.allMedia];

    if (e.target.checked) {
      updatedList = [
        ...updatedList,
        { MediaId: id, Image: image, index: props.index },
      ];
    } else {
      // updatedList=updatedList.filter((item) => item.MediaId != id)
      for (var i = 0; i < updatedList.length; i++) {
        if (updatedList[i].MediaId == id) {
          updatedList.splice(i, 1);
        }
      }
    }
    props.setAllMedia(updatedList);
  }

  // Update alt text for an uploaded image
    const handleAltChange = (index, value) => {
      setUploadedImages(prev => {
        const updated = [...prev];
        updated[index].alt = value;
        return updated;
      });
    };

    // Save all uploaded images with alt text
        const saveUploadedImages = async () => {
          const token = Cookies.get("UserToken");
        
          for (let img of uploadedImages) {
            await fetch(Variables.API_URL + "UploadMedia/InsertMedia", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                image: img.imagePath,
                imageTitle: img.imageTitle,
                altText: img.alt,
                description: "",
                caption: "",
              }),
            });
          }
        
          toast.success("Images saved successfully!");
          setUploadedImages([]); // clear temporary list
          fetchMedia(); // refresh library
        };

        const handleAltTextChange = (e, mediaId) => {
                const newValue = e.target.value;
                setFilteredData(prevData =>
                  prevData.map(img =>
                    img.MediaId === mediaId ? { ...img, AltText: newValue } : img
                  )
                );
              };
              
              const handleAltTextSave = async (mediaId, altText) => {
                try {
                  const token = Cookies.get("UserToken");
                  const response = await fetch(`${Variables.API_URL}UploadMedia/UpdateAltText`, {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Authorization": `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      MediaId: mediaId,
                      AltText: altText
                    })
                  });
                
                  if (!response.ok) throw new Error("Failed to update Alt text");
                
                  console.log("Alt text updated successfully!");
                } catch (error) {
                  console.error(error);
                }
              };

  const handleDrop = async (files) => {
    const token = Cookies.get("UserToken");
    let count = 0;
  
    for (let file of files) {
      if (file.size >= 2000000) {
        count++;
      } else {
        const formData = new FormData();
        formData.append("Image", file);
  
        try {
          const res = await axios.post(
            Variables.API_URL + "UploadMedia/UploadImageToServer",
            formData,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
              },
            }
          );
  
          if (res.data) {
            // Add to local state so we can show & edit alt before saving to DB
            setUploadedImages(prev => [
              ...prev,
              {
                imagePath: res.data, // server path returned
                alt: "",
                imageTitle: file.name.split(".").slice(0, -1).join(".")
              }
            ]);
  
            console.log("Image uploaded successfully:", res.data);
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    }
  
    if (count > 0) {
      toast.error(`${count} image(s) not accepted (over 2MB)`);
    }
  };

  function fetchMedia() {
    fetch(Variables.API_URL + "UploadMedia/GetMedia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((Response) => Response.json())
      .then((Result) => {
        setMedia(Result);
        setFilteredData(Result);
      });
  }

  function handleChoose() {
    var array = [...props.variations];
    var list = [...props.allMedia];
    var updatedList = [];
    for (var k = 0; k < list.length; k++) {
      if (list[k].index == props.index) {
        updatedList.push(list[k]);
      }
    }
    if (updatedList.length > 5) {
      toast.error("Please choose 5 pictures only");
    } else {
      for (var j = 0; j < array.length; j++) {
        if (array[j].index == props.index) {
          for (var i = 0; i < 5; i++) {
            if (updatedList[i] === undefined) {
              array[j]["ImageId" + i] = 0;
              array[j]["Image" + i] = "";
            } else {
              array[j]["ImageId" + i] = updatedList[i].MediaId;
              array[j]["Image" + i] = updatedList[i].Image;
            }
          }
        }
      }

      props.setVariations(array);
      setShow(false);
    }
  }
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = Media.filter((data) => {
      return data.ImageTitle.search(value) != -1;
    });
    setFilteredData(result);
  };

  function handleShowMore() {
    setFilteredData(Media);
    setShowMore(false);
  }

  function handleShowLess() {
    var array = [];
    for (var i = 0; i < 12; i++) {
      array.push(Media[i]);
    }
    setFilteredData(array);
    setShowMore(true);
  }

  function handleShowImageDetails(image) {
    setShowImageDetails(true);
    setImageDetails(image);
  }
  useEffect(() => {
    fetchMedia();
  }, []);

  return (
    <div className="col-12">
      <Button
        className="me-2 btn btn-secondary btn-sm"
        onClick={() => handleShow(true)}
        style={{
          height: "50px",
          marginTop: "20px",
          width: "200px",
          marginBottom: "20px",
        }}
      >
        <BiImage />{" "}
      </Button>

      <Modal show={show}  onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add images to variation gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            defaultActiveKey="Library"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="Upload" title="Upload File">
              <div className="row mt-3">
                <Dropzone
                  onDrop={handleDrop}
                  accept="image/jpeg,image/png,image/jpg,image/svg"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: "dropzone p-4 border" })}>
                      <input {...getInputProps()} />
                      <p>Drag & drop images here, or click to select files</p>
                    </div>
                  )}
                </Dropzone>
              </div>
            
              {/* Show uploaded images for alt editing */}
              {uploadedImages.length > 0 && (
                <div className="mt-4">
                  <div className="row">
                    {uploadedImages.map((img, idx) => (
                      <div key={idx} className="col-3 text-center">
                        <img
                          src={Variables.API_PUBLISHED + img.imagePath}
                          alt=""
                          className="img-fluid border"
                        />
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Alt text"
                          value={img.alt}
                          onChange={(e) => handleAltChange(idx, e.target.value)}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="mt-3 text-end">
                    <Button variant="primary" onClick={saveUploadedImages}>
                      Save All
                    </Button>
                  </div>
                </div>
              )}
            </Tab>
            <Tab eventKey="Library" title="Media Library">
              <div className="col-12">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-3">
                      <input
                        type="search"
                        className="form-control"
                        onChange={(e) => handleSearch(e)}
                        placeholder={"Search media by name"}
                      />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-12">
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      *Important:* To update the Alt Text for each image, edit the input below and press <strong>Enter</strong>. Your changes will be saved immediately.
                    </p>
                  </div>
                    <PaginatedList
                      list={filteredData}
                      itemsPerPage={18}
                      displayRange={2}
                      showPrev={false}
                      showNext={false}
                      renderList={(list) => (
                        <>
                            <div className="row">
                          {list.map((image, id) => {
                            return (
                              <div className="col-2" key={image.MediaId}>
                              <div className="imagecontainer">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={image.MediaId}
                                    id={image.MediaId}
                                    onChange={(e) =>
                                      handleImages(e, image.MediaId, image.Image)
                                    }
                                    checked={
                                      props.allMedia.filter(
                                        (value) =>
                                          value.MediaId == image.MediaId &&
                                          value.index == props.index
                                      ).length !== 0
                                        ? props.allMedia.filter(
                                            (value) =>
                                              value.MediaId == image.MediaId &&
                                              value.index == props.index
                                          )[0].MediaId
                                        : 0
                                    }
                                  />
                                  <button
                                    className="btn "
                                    onClick={() => handleShowImageDetails(image)}
                                  >
                                    <label className="form-check-label">
                                      <img
                                        alt="media"
                                        className="form-control"
                                        src={Variables.API_PUBLISHED + image.Image}
                                      />
                                    </label>
                                  </button>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={image.AltText || ""}
                                    onChange={(e) => handleAltTextChange(e, image.MediaId)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        handleAltTextSave(image.MediaId, image.AltText);
                                      }
                                    }}
                                    placeholder={"Alt text"}
                                  />
                                </div>
                              </div>
                            </div>
                            );
                          })}
                          </div>
                        </>
                      )}
                    />
                  </div>
              </div>
         
              <div className="row">
                <div className="card-footer text-right">
                  <button className="btn btn-primary" onClick={handleChoose}>
                    Choose
                  </button>
                </div>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>

      {showImageDetails === true ? (
        <Modal
          show={showImageDetails}
          fullscreen={false}
          onHide={() => setShowImageDetails(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Image Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <label style={{ fontWeight: "bolder" }}>
                    {" "}
                    Image Title :{" "}
                  </label>{" "}
                  {imageDetails.ImageTitle}
                </div>
                <div className="col-12">
                  <label style={{ fontWeight: "bolder" }}> Image Path : </label>{" "}
                  {imageDetails.Image}
                </div>
                <div className="col-12">
                  <label style={{ fontWeight: "bolder" }}>
                    {" "}
                    Uploaded Date :{" "}
                  </label>{" "}
                  {imageDetails.UploadedDate}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </div>
  );
}

export default VariationGallery;
